<div class="pt-5 bg-azulOscuro">
    <div class="grid grid-cols-12 gap-5">

      <div class="panel col-span-12 md:col-span-3 xl:col-span-3 w-full">
        <div class=" flex items-center justify-center">
          <h5 class="text-lg font-semibold dark:text-white-light animate__animated animate__jackInTheBox animate__delay-1s">
            {{ 'PROFILE.PROFILE' | translate }}
          </h5>
          <a
            (click)="goToEditProfile()"
            class="btn btn-primary rounded-full p-2 cursor-pointer ltr:ml-auto rtl:mr-auto animate-pulse"
          >
            <icon-pencil-paper />
          </a>
        </div>
        <div class="">
          <div class="flex flex-col items-center justify-center">
            <img
              [src]="selectedAvatar"
              alt="Avatar"
              class=" h-24 w-24 rounded-full object-cover animate__animated animate__jackInTheBox animate__delay-1s"
            />
            <p class="text-xl font-semibold text-primary">{{ profile.name.full_name }}  </p>
          </div>
          <ul class="m-auto mt-5 flex max-w-[160px] flex-col space-y-4 font-semibold text-black dark:text-white-dark">
            <!-- <li class="flex items-center gap-2">
              <icon-coffee class="shrink-0" />
              Tecnico
            </li> -->
            <!-- <li class="flex items-center gap-2">
              <icon-calendar class="shrink-0" />
              {{ 'PROFILE.BIRTHDAY' | translate }}
            </li> -->
            <li class="flex items-center gap-2">
              <icon-map-pin class="shrink-0" />
              {{ profile.country.name }} {{ profile.department.name }} - {{ profile.city.name }}
            </li>
            <li>
              <a href="mailto:juan@gmail.com" class="flex items-center gap-2 text-primary">
                <icon-mail class="h-5 w-5 shrink-0" />
                <span class="truncate">{{ profile.email }}</span>
              </a>
            </li>
            <li class="flex items-center gap-2">
              <icon-phone />
              <span class="whitespace-nowrap" dir="ltr"> {{ profile.phone.code }} {{ profile.phone.number }}</span>
            </li>
          </ul>
          <ul class="mt-7 flex items-center justify-center gap-2">
            <li>
              <a
                target="_blank"
                href="https://x.com/Juancamoller"
                class="btn btn-info flex h-10 w-10 items-center justify-center rounded-full p-0"
              >
              <span class="w-5 h-5 flex items-center justify-center">
                  <icon-twitter class="text-white" />
                </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.facebook.com/Pitzon.io?locale=fo_FO"
                class="btn btn-danger flex h-10 w-10 items-center justify-center rounded-full p-0"
              >
              <span class="w-5 h-5 flex items-center justify-center">
                  <icon-facebook class="text-white"/>
                </span>
              </a>
            </li>
            <li class="list-none">
                <a
                  target="_blank"
                  href="https://www.instagram.com/pitzon.io/"
                  class="btn btn-dark flex h-10 w-10 items-center justify-center rounded-full p-0"
                >
                  <span class="w-5 h-5 flex items-center justify-center">
                    <icon-instagram class="text-white" />
                  </span>
                </a>
              </li>

          </ul>

          <!-- Botón para eliminar cuenta -->
          <div class="mt-5 flex justify-center">
            <button
              (click)="openDeleteModal()"
              class="btn btn-danger px-1 py-1 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
              </svg>
              {{ 'PROFILE.DELETE_ACCOUNT' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="panel col-span-12 md:col-span-9 xl:col-span-9">
        <app-assistant></app-assistant>
      </div>
    </div>
  </div>

<!-- Modal para confirmación de eliminación de cuenta -->
<div *ngIf="showDeleteModal" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 transition-opacity" aria-hidden="true">
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-gray-900">Eliminar cuenta</h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500">
                Su cuenta será eliminada en 24 horas. Esta acción no se puede deshacer.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button (click)="confirmDeleteAccount()" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
          Confirmar
        </button>
        <button (click)="closeDeleteModal()" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
